module.exports = __webpack_public_path__ + "img/favicon.6d2f4861.png";